export default "__VITE_ASSET__CcSQQPHw__"